import ajax from '@/modules/ajax';

export default class Local {
  constructor(options) {
    this.citySelect = $('#gridy_where_city, #city');
    this.neighborhoodSelect = $('#gridy_where_neighborhood, #neighborhood');
    this.options = $.extend({}, { count_param: 'total' }, options);
    this.ufSelect = $('#gridy_where_uf, #uf');
  }

  bindUfSelect() {
    const that = this;

    this.ufSelect.on('change', function () {
      if (that.neighborhoodSelect.length) {
        that.neighborhoodSelect.val('').attr('disabled', 'disabled');
      }

      that.citySelect.val('');

      if (this.value) {
        that.citySelect.removeAttr('disabled');
        that.populatesCities(this);
      } else {
        that.citySelect.attr('disabled', 'disabled');
      }
    });
  }

  bindCitySelect() {
    const that = this;

    this.citySelect.on('change', function () {
      that.neighborhoodSelect.val('');

      if (this.value) {
        that.populatesNeighborhoods(that.ufSelect[0], this);
        that.neighborhoodSelect.removeAttr('disabled');
      } else {
        that.neighborhoodSelect.attr('disabled', 'disabled');
      }
    });
  }

  bind() {
    this.bindUfSelect();

    if (this.neighborhoodSelect.length) {
      this.bindCitySelect();
    }
  }

  create() {
    this.bind();
  }

  populatesCities(ufSelect) {
    const count_param = this.options.count_param;
    const url = `/api/addresses/ufs/${ufSelect.value}/cities`;

    ajax({
      params: { count_param: count_param },
      done: (json) => this.citySelect.html(this.#buildOptions(json.cities)),
      url: url,
    });
  }

  populatesNeighborhoods(ufSelect, citySelect) {
    ajax({
      done: (json) => this.neighborhoodSelect.html(this.#buildOptions(json.neighborhoods)),
      url: `/api/addresses/ufs/${ufSelect.value}/cities/${citySelect.value}/neighborhoods`,
    });
  }

  // private

  #buildOptions(items) {
    const options = [];

    for (let i = 0; i < items.length; i++) {
      options.push(`<option value="${items[i]['slug']}">${items[i]['name']}</option>`);
    }

    return options.join('');
  }
}
